const TokenKey = "token";
const TicketKey = "Ticket";
const Identity = "Identity";

export function setToken(token) {
  // return window.localStorage.setItem(TokenKey, token);
  return window.sessionStorage.setItem(TokenKey, token);
}

export function getToken() {
  return window.sessionStorage.getItem(TokenKey);
}

export function removeToken() {
  return window.sessionStorage.removeItem(TokenKey);
}

export function setTicket(ticket) {
  return window.sessionStorage.setItem(TicketKey, ticket);
}
export function setUserInfo(userInfo) {
  return window.sessionStorage.setItem('UserInfo',userInfo);
}


export function getTicket() {
  return window.sessionStorage.getItem(TicketKey);
}

export function removeTicket() {
  return window.sessionStorage.removeItem(TicketKey);
}

export function setIdentity(identity) {
  return window.sessionStorage.setItem(Identity, identity);
}

export function getIdentity() {
  return window.sessionStorage.getItem(Identity);
}

export function removeIdentity() {
  return window.sessionStorage.removeItem(Identity);

}

